module.exports = __webpack_public_path__ + "static/media/icon_j.2a758ce3.svg";